import { Message } from "react-chatbotify";
import type { JSX } from "react";

export type InjectMessageFn = (
  content: string | JSX.Element,
  sender?: string
) => Promise<Message | null>;

export let botInjector: InjectMessageFn | null = null;

export const setBotInjector = (injector: InjectMessageFn) => {
  botInjector = injector;
};
